export default __webpack_public_path__ + "static/media/28_TopRightSquares_Alpha.58e2bfd1.mp4";